import { render } from "./NewFolderDialog.vue?vue&type=template&id=dd5f1096"
import script from "./NewFolderDialog.vue?vue&type=script&lang=js"
export * from "./NewFolderDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__